import React from 'react';
import './FormErrorWrapper.css';

/**
 * FormErrorWrapper component that wraps form elements and displays error messages
 *
 * @param {React.ReactNode} children - The form element to wrap
 * @param {string|string[]} error - Error message(s) to display, can be a string or array of strings
 */
const FormErrorWrapper = ({ children, error }) => {
  const hasError = !!error && (typeof error === 'string' ? error.trim() !== '' : error.length > 0);
  const errorMessages = Array.isArray(error) ? error : [error];

  return (
    <div className={`form-error-wrapper ${hasError ? 'has-error' : ''}`}>
      {React.cloneElement(children, {
        className: `${children.props.className || ''} ${hasError ? 'input-error' : ''}`.trim()
      })}

      {hasError && (
        <div className="error-messages">
          {errorMessages.map((message, index) => (
            <div key={index} className="error-message">
              {message}
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default FormErrorWrapper;